/* eslint-disable max-lines */
import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Loader, Modal, Button } from 'sa-ui';
import queryString from 'query-string';

import { decodeText } from 'app/utils/strings';

import { promisify } from '../app/actions';
import * as studentActions from './studentSimulatedActions';

import messages from './studentSimulatedMessages';

import ReportCardStudent from '../reports/application-detail/report-card/ReportCardStudent';
import Chart from '../reports/GenericReportBarChart';
import AssessmentCycleTable from '../reports/AssessmentCycleTable';
import HitPerformancePerAbility from '../reports/HitPerformancePerAbility';
import StudentPerformancePerGrade from '../reports/application-detail/report-card/StudentPerformancePerGrade';

import * as helpers from './studentSimulatedHelpers';

import './StudentSimulatedReport.scss';

function parseMedia(text) {
  return text ? text.replace(/\/cp\/cpdata\/uploads/g, process.env.REACT_APP_FILES_API) : '';
}

function toCurricularPerformanceSeries(gradeByDiscipline) {
  if (gradeByDiscipline.length === 0) return [];
  return gradeByDiscipline.map((g, index) => ({
    name: g.name,
    data: g.average,
    courseAverage: g.courseAverage,
    index,
  }));
}

function toPerformanceSeries(gradeReportStudent, intl) {
  if (Object.keys(gradeReportStudent).length === 0) return [];
  return [
    {
      name: intl.formatMessage(messages.studentGrade),
      data: gradeReportStudent.studentGrade,
    },
    {
      name: intl.formatMessage(messages.studentGroupAverage),
      data: gradeReportStudent.studentGroupAvg,
    },
    {
      name: intl.formatMessage(messages.schoolAverage),
      data: gradeReportStudent.schoolAvg,
    },
    {
      name: intl.formatMessage(messages.overallAveragePerformance),
      data: gradeReportStudent.overallAvg,
    },
  ];
}

function getInitialRankingLimit() {
  const params = queryString.parse(window.location.search.replace('?', ''));
  return params.rankingLimit ? Number(params.rankingLimit) : 10;
}

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const studentSimularedReport = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [socketMessage, setSocketMessage] = useState('');
  const schoolOptions = helpers.getFASchoolOptions(props.filtersComponents.schools);
  const classesOptions = helpers.getFComponentsClassesOptions(props.filtersComponents.courses);
  const studentsOptions = helpers.getFComponentsStudentsOptions(props.filtersComponents.students);
  const [evaluationSelected, setEvaluationSelected] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [percentHitsAux, setPercentHitsAux] = useState(0);
  const [showModalEssay, setShowModalEssay] = useState(false);

  const [hasEssaySSO, setHasEssaySSO] = useState(false);

  const [rankingLimit, setRankingLimit] = useState(getInitialRankingLimit);

  const [filter, setFilter] = useState(queryString.parse(window.location.search.replace('?', '')));
  const [studentInfo, setStudentInfo] = useState({});

  const { href } = window.location;
  const prevUrl = usePrevious({ href });

  async function handleShowModal(idQuestion, percentHits) {
    // console.log(idQuestion, percentHits);
    setLoading(true);
    try {
      await props.getESQuestionDetail({
        idEvaluation: props.idEvaluation,
        idQuestion,
        percentHits: percentHits.toString(),
        idCSchool: props.filtersComponents.schools[0].idCSchool,
        idESCourse: props.filtersComponents.idESCourse,
      });
    } finally {
      setPercentHitsAux(percentHits);
      setShowModal(true);
      setLoading(false);
    }
  }

  async function handleAPIs(idCSchool, idESCourse, idESUser) {
    await setLoading(true);
    try {
      await props.getESGradeDetailByStudent({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeByDiscipline({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeStudentQuestions({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeReportStudent({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESQuestionsDetailsByComponents({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESGradeDetailAlternativeReport({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
      await props.getESEvaluationsCicleStudent({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
        idESUser,
      });
    } finally {
      setLoading(false);
    }
  }

  async function selectFilter(idCSchool, idESCourse, idESUser) {
    setFilter({ ...filter, idCSchool });
    try {
      setLoading(true);
      await props.getESFiltersComponents({
        idEvaluation: props.idEvaluation,
        idCSchool,
        idESCourse,
      });
    } finally {
      if (idCSchool && idESCourse && idESUser) {
        //   handleAPIs(idCSchool, idESCourse, idESUser);
      } else {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    props.getGroups();
    props.getEvaluations();
    props.getEssaySsoUrl();
  }, []);

  useEffect(() => {
    if (props.essaySSOUrl) {
      setHasEssaySSO(true);
    }
  }, [props.essaySSOUrl]);

  useEffect(() => {
    if (filter.idCSchool || filter.idESCourse || filter.idESUser) {
      selectFilter(filter.idCSchool, filter.idESCourse, filter.idESUser);
    } else if (!filter.idCSchool && !filter.idESCourse && !filter.idESUser) {
      props.getESFiltersComponents({
        idEvaluation: props.idEvaluation,
      });
    }
    if (filter.idCSchool && filter.idESCourse && filter.idESUser) {
      handleAPIs(filter.idCSchool, filter.idESCourse, filter.idESUser);
    }
    if (filter.idESUser) {
      props.getEvaluations({ idESUser: filter.idESUser });
    }
  }, [props.idEvaluation, filter.idCSchool, filter.idESCourse, filter.idESUser]);

  useEffect(() => {
    if (props.filtersComponents) {
      if (props.filtersComponents.length === 1) {
        setFilter({
          ...filter,
          idCSchool: props.filtersComponents[0].idCSchool,
        });
      }
      const schoolSelected = schoolOptions.find((s) => s.value === filter.idCSchool) || {};
      const courseSelected = classesOptions.find((c) => c.value === filter.idESCourse) || {};
      const studentSelected = studentsOptions.find((s) => s.value === filter.idESUser) || {};
      setStudentInfo({
        schoolName: schoolSelected.label,
        courseName: courseSelected.label,
        studentName: studentSelected.label,
      });
    }
  }, [props.filtersComponents]);

  const performanceSeries = toPerformanceSeries(props.gradeReportStudent, props.intl);
  const curricularPerformanceSeries = toCurricularPerformanceSeries(
    props.gradeByDiscipline,
    props.intl,
  );

  useImperativeHandle(props.forwardRef, () => ({
    getFilter: () => filter,
  }));

  useEffect(() => {
    if (
      props.gradeReportStudent &&
      props.gradeByDiscipline &&
      props.alternativeReport &&
      props.cicleStudent
    ) {
      setTimeout(() => window.dispatchEvent(new CustomEvent('app-ready')));
    }
  }, [
    props.gradeReportStudent,
    props.gradeByDiscipline,
    props.alternativeReport,
    props.cicleStudent,
  ]);

  function goBack() {
    props.history.goBack();
  }

  useEffect(() => {
    const evaluation = props.evaluations.filter((el) => el.id === props.idEvaluation);

    if (evaluation.length > 0) {
      setEvaluationSelected(evaluation);
      setFilter({
        ...filter,
        idCSchool: evaluation[0].idCSchool,
        idESCourse: evaluation[0].idESCourse,
        idESUser: evaluation[0].idESUser,
      });
    }
  }, [props.evaluations]);

  useEffect(() => {
    if (prevUrl) {
      if (prevUrl.href !== href) {
        location.reload();
      }
    }
  }, [prevUrl]);

  function handleEssaySSO() {
    setShowModalEssay(true);
  }

  function handleCloseModalEssay() {
    setShowModalEssay(false);
    props.getEssaySsoUrl();
  }

  return (
    <div>
      <Loader show={loading} message={loadingMessage} batchMessage={socketMessage} />
      <div>
        <Row className="align-items-end d-print-none">
          <Col md={12}>
            <a className="return" onClick={goBack}>
              <i className="ti-arrow-left" /> 
              {props.intl.formatMessage(messages.back)}
            </a>
            <h5 className="title">{props.intl.formatMessage(messages.titleStudent)}</h5>
          </Col>
        </Row>

        <div className="d-flex align-items-center justify-content-between">
          {evaluationSelected.length > 0 && (
            <h6 className="subtitle">
              <span>{evaluationSelected[0].catalogings.map((c) => c.name).join(' | ')} </span>
              <span>ID: {evaluationSelected[0].idString}</span>
            </h6>
          )}

          {hasEssaySSO && (
            <Button primary onClick={handleEssaySSO}>
              {props.intl.formatMessage(messages.accessEssayCorrections)}
            </Button>
          )}
        </div>
        <hr />
      </div>

      <div id="divToPDF" className="divToPDF">
        <div>
          {studentInfo.studentName && (
            <Row className="mt-3">
              <Col xs={12}>
                <ReportCardStudent {...props.gradeDetailStudent} {...studentInfo} />
              </Col>
            </Row>
          )}
          <Row className="mt-3">
            <Col xs={12}>
              <StudentPerformancePerGrade
                items={props.studentQuestions}
                title={props.intl.formatMessage(messages.studentPerformanceByQuestion)}
                answer={props.intl.formatMessage(messages.yourAnswer)}
                correct={props.intl.formatMessage(messages.correct)}
                limit={rankingLimit}
                handleModal={(idQuestion, percentHits) => handleShowModal(idQuestion, percentHits)}
                studentReport
              />
            </Col>
          </Row>
          {performanceSeries.length > 0 && (
            <Row className="mt-3">
              <Col xs={12}>
                <Chart
                  title={props.intl.formatMessage(messages.performanceComparison)}
                  series={performanceSeries}
                  barWidth={25}
                />
              </Col>
            </Row>
          )}
          {curricularPerformanceSeries.length > 0 && (
            <Row className="mt-3">
              <Col xs={12}>
                <Chart
                  title={props.intl.formatMessage(messages.studentPerformanceByComponent)}
                  series={curricularPerformanceSeries}
                  barWidth={25}
                />
              </Col>
            </Row>
          )}
          {props.alternativeReport && props.alternativeReport.length > 0 && (
            <Row className="mt-3">
              <Col xs={12}>
                <HitPerformancePerAbility items={props.alternativeReport} limit={rankingLimit} />
              </Col>
            </Row>
          )}
          {props.cicleStudent && props.cicleStudent.length > 0 && (
            <Row className="mt-3">
              <Col xs={12}>
                <AssessmentCycleTable
                  items={props.cicleStudent}
                  limit={rankingLimit}
                  history={props.history}
                  idCSchool={filter.idCSchool}
                  idESCourse={filter.idESCourse}
                  idESUser={filter.idESUser}
                />
              </Col>
            </Row>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={props.intl.formatMessage(messages.questionDetail)}
        medium
      >
        {Object.keys(props.questionDetail).length > 0 ? (
          <div style={{ textAlign: 'left' }}>
            <br />
            <div className="d-flex align-items-center mb-3">
              <div className="scale scale-large" style={{ width: '50px' }}>
                <div
                  className="scale-step step-18"
                  style={{ backgroundColor: helpers.getColor(percentHitsAux) }}
                >
                  <div className="content">{percentHitsAux}%</div>
                </div>
              </div>
              <strong className="ml-3">
                {`${props.intl.formatMessage(messages.question)} ${props.questionDetail.position}`}
              </strong>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div
                  dangerouslySetInnerHTML={{
                    __html: parseMedia(decodeText(props.questionDetail.text)),
                  }}
                  className="fixText"
                />
                <br />
                {props.questionDetail.alternatives.map((a) => (
                  <div
                    className={`fixAlternative ${a.answered === '1' ? 'answered' : ''} ${
                      a.correct === '1' ? 'success' : ''
                    } `}
                  >
                    {a.letter.toLowerCase()})
                    <span
                      className="marginAlternative"
                      dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(a.text)) }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </Modal>

      <Modal show={showModalEssay} onClose={() => handleCloseModalEssay()} large>
        <iframe src={props.essaySSOUrl} frameborder="0"></iframe>
      </Modal>
    </div>
  );
};

studentSimularedReport.propTypes = {};

const mapStateToProps = ({ app, studentSimulated }, { match }) => ({
  ...match.params,
  ...studentSimulated,
  token: app.cookieToken,
  permission: app.permission,
  user: app.user,
});

export default compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    promisify(
      { ...studentActions },
      {
        include: [
          'generateBatchPdf',
          'getESFiltersComponents',
          'getESGradeByDiscipline',
          'getESGradeStudentQuestions',
          'getESGradeReportStudent',
          'getESQuestionsDetailsByComponents',
          'getESGradeDetailAlternativeReport',
          'getESEvaluationsCicleStudent',
          'getESGradeDetailByStudent',
          'getEvaluations',
          'getGroups',
          'getESQuestionDetail',
        ],
      },
    ),
  ),
)(studentSimularedReport);
